import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { COOKIE_CONSENT_KEY, COOKIE_CONSENT_VALUES } from "@constants/cookies";
import { CookieConsentBannerProps } from "@models/shared/shared.model";
import cookieConsentSlice from "@slices/cookieConsent.slice";
import { setCookie } from "@utils/common.utils";

const CookieConsentBanner = ({
  currentConsent,
  isBannerExpanded,
  onClose,
}: CookieConsentBannerProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleAcceptAll = () => {
    dispatch(cookieConsentSlice.actions.setConsent(COOKIE_CONSENT_VALUES.ALL));
    setCookie(COOKIE_CONSENT_KEY, COOKIE_CONSENT_VALUES.ALL);
    dispatch(cookieConsentSlice.actions.setBannerExpanded(false));
    window.location.reload();
  };

  const handleNecessaryOnly = () => {
    dispatch(
      cookieConsentSlice.actions.setConsent(COOKIE_CONSENT_VALUES.NECESSARY)
    );
    setCookie(COOKIE_CONSENT_KEY, COOKIE_CONSENT_VALUES.NECESSARY);
    dispatch(cookieConsentSlice.actions.setBannerExpanded(false));
    window.location.reload();
  };

  const handleClose = () => {
    dispatch(cookieConsentSlice.actions.setBannerExpanded(false));
    if (onClose) onClose();
  };
  return (
    <div className={`fg-cookie-banner ${isBannerExpanded ? "is-open" : ""}`}>
      <div className="fg-cookie-banner-content">
        <button
          className="fg-cookie-close-btn"
          onClick={handleClose}
          type="button"
          aria-label="Close"
        >
          x
        </button>

        <div className="fg-cookie-modal-content">
          <div className="fg-cookie-modal-text">
            <h2 className="fg-cookie-modal-title">{t("cookie.consent")}</h2>
            <p className="fg-cookie-banner-description">
              {t("cookie.description")}&nbsp;
              <a
                target="_blank"
                href="/cookie-policy"
                className="fg-cookie-banner-policy"
                id="fg-cookie-banner-policy"
              >
                {t("cookie.policy")}
              </a>
            </p>
          </div>
        </div>

        <div className="fg-cookie-banner-buttons">
          <button
            className="btn btn-primary fg-cookie-accept-all-btn"
            onClick={handleAcceptAll}
            type="button"
            disabled={currentConsent === COOKIE_CONSENT_VALUES.ALL}
          >
            {t("cookie.acceptAll")}
          </button>
          <button
            className="btn btn-secondary fg-cookie-necessary-btn"
            onClick={handleNecessaryOnly}
            type="button"
            disabled={currentConsent === COOKIE_CONSENT_VALUES.NECESSARY}
          >
            {t("cookie.necessaryOnly")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
